import { iterateBreakpointsToObjects } from 'app/functions/grid';

/**
 * This function will provide an array of widths which indicate the
 * widths of a box in different breakpoints. As with "buildSpacing",
 * the object passed can be used to specify what width will be used
 * in what breakpoint. As this are percentage widths, specifying
 * "1" will give a 100% width, "0.5" a 50% width, etc.
 *
 * If a breakpoint is not specified, the width will default to 100%
 * if any previous breakpoint wasn't specified. Defining the width
 * of a breakpoint will make the larger breakpoints use the same value
 * unless otherwise specified.
 * Calling this function without parameters will return:
 *
 *      [1, 1, 1]
 *
 * which means that the box will have a width of 100% in all breakpoints.
 * When passing the object { medium: 0.5 }, however, the returned value will be:
 *
 *      [1, 0.5, 0.5]
 *
 * @param sizes
 */
export const buildWidth = (sizes = {}, defaultSize = 1) =>
    iterateBreakpointsToObjects().reduce((acc, { name }) => [
        ...acc,
        name in sizes ? sizes[name] : acc.slice(-1)[0] || defaultSize,
    ], []);
